import {injectable, Inject} from 'inversify-props';
import HttpClient from "./http-client";

@injectable()
export class TasksService {

    readonly taskCheckExpiration = "1";

    @Inject() httpClient: HttpClient;

    constructor() {
    }

    public runTask(payload: any) {
        return this.httpClient.post('/tasks/run', payload)
            .then(res => {
                return res.data.response[0];
            });
    }

}